<script>
  import { onMount, onDestroy } from "svelte";
  import request from 'superagent';
  import { createEventDispatcher } from 'svelte';
  import Editor from './editor.svelte';
  const dispatch = createEventDispatcher();
  
  const defaultDoc = {title: "", subtitle: "", preable: "", signatures: "", articles: []};
  
  export let form_id = '';
  export let locale = 'cs';
  
  let doc = Object.assign({}, defaultDoc);
  let focused_article_index = 0;
  
  let visible_paragraph_form = false,
      visible_document_form  = false;
  
  function toggleDocumentForm() {
    visible_paragraph_form = !visible_paragraph_form;
  }
  function toggleParagraphForm() {
    visible_document_form = !visible_document_form;
  }
  
  onMount(() => {
  })
  
  onDestroy(() => {
    if (preable_editor) {
      preable_editor.destroy()
    }
  })
  
  function commit() {
    alert(JSON.stringify(editor.getJSON()));
  }
  
  function download() {
    alert(JSON.stringify(editor.getJSON()));
  }
  
  function changeFolder() {
    // TODO
  }
  
  function preview() {
    // TODO
  }
  
  export function dragover(ev) {
    ev.preventDefault();
    ev.dataTransfer.dropEffect = 'move';
  }
  
  export function registerParagraph(ev, hoveredIndex) {
    ev.preventDefault();
    var component = JSON.parse(ev.dataTransfer.getData("text/plain"));
    console.log("registerParagraph", component)
    if (hoveredIndex < 0)
      doc["articles"][focused_article_index].paragraphs = [...doc["articles"][focused_article_index].paragraphs, component];
    else
      doc["articles"][focused_article_index].paragraphs = [component, ...doc["articles"][focused_article_index].paragraphs];
    doc = doc;
  }
  
  export function registerArticle(ev, hoveredIndex) {
    ev.preventDefault();
    var component = JSON.parse(ev.dataTransfer.getData("text/plain"));
    console.log("registerArticle", component)
    if (hoveredIndex < 0)
      doc["articles"] = [...doc["articles"], component];
    else
      doc["articles"] = [component, ...doc["articles"]];
    doc = doc;
  
    /*
    registerComponent(window.atob(item_id), component, resp => {
        if (!doc.articles)
          doc["articles"] = [];
        doc["articles"].push(component);
    });*/
  }
</script>
<div class='d-flex justify-content-start'>
<div class='btn btn-link text-primary' on:click|preventDefault='{changeFolder}' title='Změnit složku' type='submit'>
<i class='fa fa-folder'></i>
<span class='d-none'>
Změnit složku
</span>
</div>
<div class='btn btn-link text-primary' on:click|preventDefault='{preview}' title='Náhled' type='submit'>
<i class='fa fa-eye'></i>
<span class='d-none'>
Náhled
</span>
</div>
<div class='btn btn-link text-primary' on:click|preventDefault='{commit}' title='Uložit' type='submit'>
<i class='fa fa-save'></i>
<span class='d-none'>
Uložit
</span>
</div>
<div class='btn btn-link text-primary' on:click|preventDefault='{download}' title='Stáhnout' type='submit'>
<i class='fa fa-download'></i>
<span class='d-none'>
Stáhnout
</span>
</div>
</div>
<div class='card'>
<div class='card-body'>
<form action='/form/terms/{form_id}' class='form'>
<fieldset class='form-group'>
<label class='form-text text-muted' for='document-title'>Název dokumentu</label>
<input bind:value='{doc.title}' class='form-control ui' id='document-title' type='text'>
</fieldset>
<fieldset class='form-group'>
<label class='form-text text-muted' for='document-subtitle'>Podtitul</label>
<input bind:value='{doc.subtitle}' class='form-control ui' id='document-subtitle' type='text'>
</fieldset>
<fieldset class='form-group'>
<Editor>
<label class='form-text text-muted' for='document-preamble'>Preambule</label>
</Editor>
</fieldset>
<fieldset class='form-group' id='document-articles'>
<div class='droplet mb-1' on:dragover='{dragover}' on:drop='{event => registerArticle(event, 0)}'></div>
{#each doc.articles as {name, paragraphs}, i}
<article on:dragover='{dragover}' on:drop='{event => registerParagraph(event, i)}'>
<h3>
<input bind:value='{doc.articles[i].name}' class='border-0' type='text'>
</h3>
{#if paragraphs}
{#each paragraphs as {name, content}, ii}
<p>
<Editor content='{content}' visible_font_sizes='{false}'>
<label class='form-text text-muted' for='document-acticle-paragraph'>{ii+1}</label>
</Editor>
</p>
{/each}
{/if}
</article>
{/each}
<div class='droplet mt-1' on:dragover='{dragover}' on:drop='{event => registerArticle(event, -1)}'></div>
</fieldset>
<fieldset class='form-group'>
<Editor>
<label class='form-text text-muted' for='document-subs'>Podpisová část</label>
</Editor>
</fieldset>
</form>
</div>
</div>
